<mat-chip-option
  [disableRipple]="true"
  [selectable]="false"
  [selected]="isActive()"
  [disabled]="disabled()"
  (removed)="clear.emit()"
>
  {{ config().label }}

  @if (!isActive()) {
    <ui-icon matChipTrailingIcon class="caret" [faName]="opened() ? 'caret-up' : 'caret-down'" faStyle="solid"></ui-icon>
  } @else {
    <button matChipRemove>
      <ui-icon faStyle="light" faName="xmark"></ui-icon>
    </button>
  }
</mat-chip-option>
